import {useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {Icon, Tooltip, Initials} from 'components';
import {TRANSLATION_KEYS} from 'locale';
import {sessionUtils} from 'utils';

const T_KEYS = TRANSLATION_KEYS.COMPONENTS.USER_INITIALS;

type Props = {
    user: {
        email: string;
        firstName: string;
        lastName: string;
        activated?: boolean;
    },
    colored?: boolean;
    size?: 'lg' | '2xl' | '3xl';
    className?: string;
    showUnactivated?: boolean;
}

export const UserInitials: React.FC<Props> = ({user, showUnactivated, size = '2xl', className, colored = true}: Props) => {
    const {t} = useTranslation();
    const unactivatedTooltip = useMemo(() => t(T_KEYS.UNACTIVATED_ACCOUNT), [t]);
    if (user) {
        const {firstName, lastName, email} = user;
        const initials = sessionUtils.getInitials(firstName, lastName);
        if (user.activated) {
            return (
                <Initials
                    initials={initials}
                    colorWord={email}
                    colored={colored}
                    className={className}
                />
            );
        }
        if (showUnactivated) {
            return (
                <Tooltip className={className} header={unactivatedTooltip}>
                    <Icon name='hourglass' size={size} color='default-dimmed' />
                </Tooltip>);
        }
        return null;
    } else {
        return (
            <Initials
                initials={
                    <Icon name='close' size='sm' />
                }
                colored={false}
                colorWord=''
                className={className}
            />
        );
    }
};
